<div class="layout-body">
  <div
    content
    gdColumns="repeat(2, 1fr)"
    gdColumns.xs="1fr"
    gdGap="8px"
    id="company-card"
  >
    @for (company of companies; track company) {
      <div class="business-card" (click)="selectCompany(company)">
        <div class="card-header">
          <div class="icon-box">
            <svg viewBox="0 0 24 24">
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
              <polyline points="9 22 9 12 15 12 15 22"></polyline>
            </svg>
          </div>
          <div class="title-area">
            <h3>
              {{ company.Name }}
            </h3>
          </div>
        </div>
        <div class="divider"></div>
        <div class="card-footer">
          <div class="address">
            <span class="city">{{ company?.ZIP }} {{ company?.City }}</span>
            <span class="country">{{ company?.Country }}</span>
          </div>
          <div class="action-btn">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </div>
        </div>
      </div>
    }
  </div>
</div>
